/**
 * Initializes the single Firebase client used by data-layer repositories.
 * Firebase web configuration is public by design; authorization is enforced by Firestore rules.
 */
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyDp9cfXCN8RW3u1qo1fdrOlbjCQgn5g-qA',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'labibur.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'labibur',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'labibur.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '642915218060',
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ??
    '1:642915218060:web:55d26dbe6b0a8b54b881a9',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? 'G-J0CMFW1T04',
} as const;

export const firebaseApp = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

/** Firebase Auth uses this OAuth client through the Google provider configured in the console. */
export const googleWebClientId =
  import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID ??
  '642915218060-cmq8m3mdbnou15anlud5mue498k15frt.apps.googleusercontent.com';

export const firebaseAuth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
